// Questions FIXES du sondage individuel mensuel (auto-déclaré par l'employé).
// Module pur (zéro import Firestore) → partageable client/serveur.
//
// Sens des échelles (1..5) — fixé ici, pas dans l'UI :
//   workload : 1 = surchargé → 5 = très confortable
//   energy   : 1 = épuisé    → 5 = plein d'énergie
// Une note BASSE signale donc toujours un risque.

export const MEMBER_PULSE_MAX = 5

export const MEMBER_PULSE_QUESTIONS = [
  {
    key: 'workload',
    label: 'Charge de travail',
    prompt: 'Comment évalues-tu ta charge de travail ce mois-ci ?',
    low: 'Surchargé',
    high: 'Très confortable',
  },
  {
    key: 'energy',
    label: 'Énergie',
    prompt: 'Comment est ton niveau d’énergie au travail ?',
    low: 'Épuisé',
    high: 'Plein d’énergie',
  },
] as const

export type MemberPulseQuestionKey = (typeof MEMBER_PULSE_QUESTIONS)[number]['key']

export const MEMBER_PULSE_COMMENT_MAX = 2000

export function isValidMemberPulseScore(value: number): boolean {
  return Number.isInteger(value) && value >= 1 && value <= MEMBER_PULSE_MAX
}
